module.exports = __webpack_public_path__ + "static/img/order_icon1.17e3aaec.svg";